// import axios from 'axios';
import {
  setupGlobals,
  useRequest as libUseRequest,
} from 'use-react-api-request';

import { useAuth } from '@shared';

setupGlobals({
  // or any other API-client that you use
  // isCancel: axios.isCancel,
});

const useRequest: typeof libUseRequest = (request, config) => {
  const { loginWithRedirect } = useAuth();

  return libUseRequest(request, {
    ...config,
    onError: (ex: any) => {
      const { onError } = config || {};
      if (typeof onError === 'function') onError(ex);

      return ex?.status === 401 ? loginWithRedirect() : null;
    },
  });
};

export { useRequest };
